<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <div class="loader">
        <!-- <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner> -->
        <idx-skeleton width="238" height="238" radius="238"></idx-skeleton>
      </div>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="reports-wrapper">
        <div style="width: 100%; margin-top: 45px;" class="card">
          <div class="chart-area">
            <radial-progress-bar
              :diameter="dataGraph.layout.h * 30"
              :stroke-width="20"
              innerStrokeColor="#f1f1f1"
              :startColor="data.scoreColor"
              :stopColor="data.scoreColor"
              :completed-steps="data.score"
              :total-steps="100"
            >
              <b
                :style="{
                  color: data.scoreColor,
                  fontSize: '2.8em',
                  fontWeight: 'bold',
                }"
              >
                {{ data.score }}
              </b>
            </radial-progress-bar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import RadialProgressBar from 'vue-radial-progress';
import Indicators from '../../reports/indicators';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  name: 'ScoreSentiment',

  components: {
    RadialProgressBar,
    Indicators,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: true,
    data: {
      totalAnswers: 0,
      totalAnswersAnalyzed: 0,
      score: 0,
      scoreColor: '#c1c1c1',
    },
    loadingIndicators: false,
  }),

  methods: {
    async getReportsData() {
      this.loading = true;

      this.getSentmentAnalysisInfo(this.dataGraph);

      this.loading = false;
    },

    async getSentmentAnalysisInfo(dataGraph) {
      const response = await api.get('/reports/sentiment-score-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          startDate: null,
          endDate: null,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: dataGraph.indicator ? dataGraph.indicator : null,
          indicatorValue: dataGraph.valueIndicator
            ? dataGraph.valueIndicator
            : null,
          // indicatorRange: this.indicatorData.range,
          period: dataGraph.period,
          _id: dataGraph._id,
        },
      });

      this.data.score = response.data.score.total;
      this.data.scoreColor = this.setColor(response.data.score.total);
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getReportsData();

    EventBus.$on('update-score-sentiment', (items) => {
      this.getReportsData(items);
    });
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  background-color: #fff;
  border-color: #fff;
  margin-top: 20px;

  h1 {
    font-size: 22px;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

// .graphic-card {
//   display: flex;
//   flex-direction: column;
//   padding: 15px 35px;
//   border: 1px solid #eee;
//   height: 100%;
// }

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/score.vue